export default "__VITE_ASSET__CLWFwunp__"